var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRockOn = function SvgRockOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "21px",
    viewBox: "0 0 14 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\uD83E\uDD18")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HY-App-Setting-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    fontSize: 17,
    fontWeight: "normal",
    "line-spacing": 24
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uD83E\\uDD18",
    fill: "#212529"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 19
  }, "\uD83E\uDD18")))));
};
export default SvgRockOn;